import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptionsArgs } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class CommonDataService {

  private _statesUrl: string = `${environment.apiRootURL}/states`;
  private _miscUrl: string = `${environment.apiRootURL}/misc`;

  constructor(private _http: Http) { }

  getStates() {
    console.log('HTTP GET states');
    return this._http.get(`${this._statesUrl}`).map(response => response.json());
  }

  getMonths() {
    console.log('HTTP GET months');
    return this._http.get(`${this._miscUrl}/months`).map(response => response.json());
  }

  getMonth(monthNumber: number) {
    console.log('HTTP GET specific month');
    return this._http.get(`${this._miscUrl}/months/${monthNumber}`).map(response => response.json());
  }

  getYears() {
    console.log('HTTP GET years');
    return this._http.get(`${this._miscUrl}/yearlist`).map(response => response.json());
  }

  getYearRange(yearCount: number) {
    console.log('HTTP GET year range');
    return this._http.get(`${this._miscUrl}/yearlist/${yearCount}`).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common-data.service.ts